import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    accessRequestAccessibilityLabel: (requesterNameOrEmail: string) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Accessibility label for access request item in the notifications list */
            accessRequestAccessibilityLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (requesterNameOrEmail: string) => __intl__.intl().formatMessage({ id: "NotificationListSection.accessRequestAccessibilityLabel?c=ozldx5s4d1og", defaultMessage: "Access request from {requesterNameOrEmail}" }, { requesterNameOrEmail: requesterNameOrEmail }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
